module.exports = __webpack_public_path__ + "img/line-selected.6acfb5b0.svg";